import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

var e =
/*#__PURE__*/
function () {
  function e() {
    var _e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "keyval-store";

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "keyval";

    _classCallCheck(this, e);

    this.storeName = t, this._dbp = new Promise(function (n, r) {
      var o = indexedDB.open(_e, 1);
      o.onerror = function () {
        return r(o.error);
      }, o.onsuccess = function () {
        return n(o.result);
      }, o.onupgradeneeded = function () {
        o.result.createObjectStore(t);
      };
    });
  }

  _createClass(e, [{
    key: "_withIDBStore",
    value: function _withIDBStore(e, t) {
      var _this = this;

      return this._dbp.then(function (n) {
        return new Promise(function (r, o) {
          var u = n.transaction(_this.storeName, e);
          u.oncomplete = function () {
            return r();
          }, u.onabort = u.onerror = function () {
            return o(u.error);
          }, t(u.objectStore(_this.storeName));
        });
      });
    }
  }]);

  return e;
}();

var t;

function n() {
  return t || (t = new e()), t;
}

function r(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : n();
  return t._withIDBStore("readwrite", function (t) {
    t.delete(e);
  });
}

var o = r,
    u = {
  maxAge: Infinity,
  version: 0,
  lib: {
    Store: e,
    get: function get(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : n();
      var r;
      return t._withIDBStore("readonly", function (t) {
        r = t.get(e);
      }).then(function () {
        return r.result;
      });
    },
    set: function set(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : n();
      return r._withIDBStore("readwrite", function (n) {
        n.put(t, e);
      });
    },
    del: r,
    clear: function clear() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : n();
      return e._withIDBStore("readwrite", function (e) {
        e.clear();
      });
    },
    keys: function keys() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : n();
      var t = [];
      return e._withIDBStore("readonly", function (e) {
        (e.openKeyCursor || e.openCursor).call(e).onsuccess = function () {
          this.result && (t.push(this.result.key), this.result.continue());
        };
      }).then(function () {
        return t;
      });
    }
  }
},
    i = function i(e) {
  return Object.assign({}, u, e);
},
    s = function s(e, t, n) {
  var r = i(t),
      o = r.maxAge,
      u = r.version,
      s = r.lib;
  return s.get(e, n).then(JSON.parse).then(function (t) {
    return Date.now() - t.time > o || u !== t.version ? (s.del(e, n), null) : t.data;
  }).catch(function () {
    return null;
  });
},
    c = function c(e, t, n, r) {
  var o = i(n);
  return o.lib.set(e, JSON.stringify({
    version: o.version,
    time: Date.now(),
    data: t
  }), r).catch(function () {
    return null;
  });
},
    a = function a(e, t) {
  var n,
      r = i(e);
  return r.lib.keys(t).then(function (e) {
    return n = e, Promise.all(n.map(function (e) {
      return s(e, r, t);
    }));
  }).then(function (e) {
    return e.reduce(function (e, t, r) {
      return t && (e[n[r]] = t), e;
    }, {});
  }).catch(function () {});
},
    l = function l(t) {
  var n,
      r = i(t);
  return r.name && (n = new e(r.name, r.name)), {
    get: function get(e) {
      return s(e, r, n);
    },
    set: function set(e, t) {
      return c(e, t, r, n);
    },
    getAll: function getAll() {
      return a(r, n);
    },
    del: function del() {
      return r.lib.del(n);
    },
    clear: function clear() {
      return r.lib.clear(n);
    },
    keys: function keys() {
      return r.lib.keys(n);
    }
  };
};

export { o as del, s as get, c as set, a as getAll, l as getConfiguredCache };